export class DependentModel {
    nome: string;
    cpf: string | null;

    constructor(nome: string, cpf: string | null) {
        this.nome = nome;
        this.cpf = cpf;
    }

    static fromApi(data: any): DependentModel {
        return new DependentModel(
            data.nome,
            data.cpf
        );
    }
}

export default class ContractInfoModel {
    idClube: number;
    clube: string;
    dataInicial: string;
    dataFinal: string;
    idContrato: number;
    idConvenio: number | null;
    idCategoria: number;
    plano: string;
    valorPlano: number;
    nomeAssociado: string;
    cpfAssociado: string;
    dependentes: DependentModel[];

    constructor(
        idClube: number,
        clube: string,
        dataInicial: string,
        dataFinal: string,
        idContrato: number,
        idConvenio: number | null,
        idCategoria: number,
        plano: string,
        valorPlano: number,
        nomeAssociado: string,
        cpfAssociado: string,
        dependentes: DependentModel[]
    ) {
        this.idClube = idClube;
        this.clube = clube;
        this.dataInicial = dataInicial;
        this.dataFinal = dataFinal;
        this.idContrato = idContrato;
        this.idConvenio = idConvenio;
        this.idCategoria = idCategoria;
        this.plano = plano;
        this.valorPlano = valorPlano;
        this.nomeAssociado = nomeAssociado;
        this.cpfAssociado = cpfAssociado;
        this.dependentes = dependentes;
    }

    static fromApiResponse(data: any): ContractInfoModel {
        return new ContractInfoModel(
            parseInt(data.id_clube),
            data.clube,
            data.data_inicial,
            data.data_final,
            data.id_contrato,
            data.id_convenio,
            parseInt(data.id_categoria),
            data.plano,
            parseFloat(data.valor_plano),
            data.nome_associado,
            data.cpf_associado,
            (data.dependentes || []).map((d: any) => DependentModel.fromApi(d))
        );
    }
}
